import { SELECTORS, useEventDataOfSelectedEvent } from "@Utils";
import { useSelector } from "react-redux";
import { getWordUsedForCourse } from "@Utils/content/utils";

const useCertificate = () => {
    const { eventData } = useEventDataOfSelectedEvent();
    const hostData = useSelector(SELECTORS.hostData);

    const { certificate } = eventData;

    const { preview_image_url: previewCertificateImage } = certificate || {};

    return {
        previewCertificateImage,
        name: eventData.creator_name,
        title: eventData?.metadata?.custom_certificate_title,
        wordUsedForCourse: getWordUsedForCourse(hostData),
    };
};

export default useCertificate;
